import { useLocation } from "react-router-dom";
import StripeBankingComplete from "../elements/stripe-banking-complete";
import StripeBankingDashboard from "../elements/stripe-banking-dashboard";
import StripeBankingRefresh from "../elements/stripe-banking-refresh";

const BankingDetailsPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");

  switch (mode) {
    case "complete":
      return <StripeBankingComplete />;
    case "refresh":
      return <StripeBankingRefresh />;
    default:
      return <StripeBankingDashboard />;
  }
};

export default BankingDetailsPage;
